import { getAccessToken } from "../forge/suite/auth";
import { loadSuiteSettings, SUITE_RELAY_URL } from "../forge/suite/settings";
import type { ChatThread } from "./types";
import { CHATFORGE_HF_BUCKET_URI } from "./hfBucket";

function forgeBase(): string {
  return (loadSuiteSettings().forgeApiUrl || SUITE_RELAY_URL).replace(/\/$/, "");
}

function authHeaders(): Record<string, string> {
  const headers: Record<string, string> = {
    Accept: "application/json",
    "Content-Type": "application/json",
    "X-Forge-App": "chatforge",
  };
  const tok = getAccessToken();
  if (tok) headers.Authorization = `Bearer ${tok}`;
  return headers;
}

export async function pullRemoteThreads(modelKey: string): Promise<ChatThread[] | null> {
  if (!getAccessToken()) return null;
  const qs = new URLSearchParams();
  if (modelKey && modelKey !== "none") qs.set("model", modelKey);
  const url = `${forgeBase()}/api/chatforge/memory${qs.toString() ? `?${qs}` : ""}`;
  const res = await fetch(url, { headers: authHeaders() });
  if (res.status === 401) return null;
  if (!res.ok) throw new Error(`memory pull ${res.status}`);
  const body = (await res.json()) as { threads?: ChatThread[] };
  return Array.isArray(body.threads) ? body.threads : [];
}

export async function pushRemoteThreads(
  threads: ChatThread[],
  modelKey: string,
): Promise<void> {
  if (!getAccessToken()) return;
  const res = await fetch(`${forgeBase()}/api/chatforge/memory`, {
    method: "PUT",
    headers: authHeaders(),
    body: JSON.stringify({
      threads,
      model: modelKey,
      bucket: CHATFORGE_HF_BUCKET_URI,
    }),
  });
  if (res.status === 401) return;
  if (!res.ok) {
    const text = await res.text().catch(() => "");
    throw new Error(text.slice(0, 180) || `memory push ${res.status}`);
  }
}


